import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferCardComponent } from './offer-card.component';
import { SharedModule } from '../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [OfferCardComponent],
  exports: [OfferCardComponent],
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule
  ]
})
export class OfferCardModule { }
